module.exports = __webpack_public_path__ + "img/GB.d39f7a13.svg";